import React from "react";

const Spacer = ({ children }) => {
  return (
    <div className="w-full relative mx-auto max-w-3xl lg:max-w-6xl px-4">
      {children}
    </div>
  );
};

export default Spacer;
